import '../../styles/speaker.css';
import logo from '../../assets/images/Q3logotext.png';
import lucy from "../../assets/images/speakers/lucy.png";

function Lucy() {
  return (
    <>
    <div class="header">
      <div class="header-content">
        <div class="left">
          <div class="header-box">
            <h1 className="title">Q<sup>3</sup> Initiative: QREATE @ UMD</h1>
          </div>
          <p>September 12, 2025 - September 13, 2025</p>
          <p>University of Maryland, College Park</p>
          <p>Stamp Student Union: Hoff Theatre</p>
        </div>
        <div className="right">
          <img src={logo} className="logo" alt="Q^3 Logo" />
        </div>
      </div>
    </div>
    <div className="speaker-box">
      <div className="speaker-photo">
         <img src={lucy} alt="Lucy Zhang" className="speakerspic"/>
      </div>
      <div className="speaker-content">
      <h1>Lucy Liuxuan Zhang</h1>
      <h2>Mathematician & Violinist</h2>
    </div>  
    </div>
    <div className="speaker-content">
      <p className="p">
        Lucy Liuxuan Zhang is an impassioned violinist and mathematical physicist who has found tremendous inspiration and utility in balancing and pursuing her two careers.  Her role at the University of Maryland allows her to further her research in topological quantum computation and to explore the intersection between music and science.  She has received multiple grants for her pioneering work on creating beautiful improvisational music while sourcing inspirations from science, often from the frontiers of research.  Her music created in this deliberate yet spontaneous manner in turn aims to help enhance scientific communications, understanding, engagement and creativity in her audience and participants.  It's her mission to unleash the fountain of creativity and curiosity in everyone. 
      </p>  
    </div>
    </>
  );
}

export default Lucy;